// extracted by mini-css-extract-plugin
export var badgeStyle = "OlIna";
export var notificationButton = "MHDaP";